import { z } from 'zod';

import { type RefreshTokenRequest, type RefreshTokenResponse } from './refresh-token.dto.js';
import { AuthTokensResponseSchema } from './session.schema.js';

export const RefreshTokenRequestSchema: z.ZodType<RefreshTokenRequest> = z.object({
  refreshToken: z.string().min(1),
});

export const RefreshTokenResponseSchema: z.ZodType<RefreshTokenResponse> = AuthTokensResponseSchema;
